<template>
  <button
    type="button"
    :class="switchClasses"
    :disabled="disabled"
    role="switch"
    :aria-checked="modelValue ? 'true' : 'false'"
    @click="toggleSwitch"
  >
    <span :class="style.thumb" />
  </button>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import style from "./SwitchComponent.module.scss";

export default defineComponent({
  name: "SwitchComponent",
  emits: ["update:modelValue", "change"],
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String as PropType<Size>,
      default: "L"
    }
  },

  data() {
    return {
      style
    };
  },

  computed: {
    switchClasses(): string[] {
      return [
        style.switch,
        style[`size${this.size}`],
        this.modelValue ? style.active : "",
        this.disabled ? style.disabled : ""
      ];
    }
  },

  methods: {
    toggleSwitch(): void {
      if (this.disabled) {
        return;
      }

      const nextValue = !this.modelValue;
      this.$emit("update:modelValue", nextValue);
      this.$emit("change", nextValue);
    }
  }
});
</script>
